import React from 'react';
import styled from 'styled-components';
import { useSpring, animated, config } from 'react-spring';
import ContributorsFilterContext from './context';
import { OptionSectionTitle } from '../common/styles';

const Title = styled(OptionSectionTitle)`
  margin-bottom: 0;
  margin-left: 8px;

  & > span {
    display: block;
    width: 100%;
    font: ${props => props.theme.fontWeightMedium} 16px/30px ${props => props.theme.fontFamilyBody};
    color: #495865;
    text-transform: none;
  }
`;

export default function Contributors() {
  const { state: { warning } } = React.useContext(ContributorsFilterContext);
  const spring = useSpring({
    color: warning ? '#b71e49' : '#495865',
    config: config.molasses,
  });

  return (
    <Title>
      filter by contributor
      <animated.span style={spring}>You must select at least one contributor</animated.span>
    </Title>
  );
}
